import React from "react";
import { Modal } from "antd";
import { ModalProps } from "antd/es/modal";

export default function ExamNotice({ ...modalProps }: ModalProps) {
    return (
        <Modal
            title="考试须知及说明"
            {...modalProps}
            cancelButtonProps={{ style: { display: "none" } }}
            okText="我知道了"
            closable={false}>
            学生本人郑重确认并承诺：
            <br />
            一、本人同意本次考试中图像通过摄像头自动采集，作为考试监控凭证。
            <br />
            二、本人承诺此次考试全过程亲自完成，并对考试结果负责。
            <br />
            <p style={{ marginTop: 20, color: "red" }}>注意事项</p>
            一、请在规定时间内作答，超出考试规定时间，系统会自动提交您已作答的内容。
            <br />
            二、考试开始后，系统会自动记录您离开考试页面的次数。
            <br />
            三、考试全过程系统会进行人脸抓拍，请确保全称是本人考试，老师会根据抓拍记录判定是否作废您本次的考试。
            <br />
            四、请确定当前登录白果云学生端的账号信息准确无误。
        </Modal>
    );
}
